import { resolveApplyEffects } from "../../../shared/layout/components/highlight/HighlightNewFeature";

const SHOW_RESULTS_END_DATE = "2025-06-20";
export const SHOW_SURVEY_RESULTS = resolveApplyEffects({
  endDate: SHOW_RESULTS_END_DATE,
});

export const RESULT_SUPPORT = [
  {
    name: "Argentina",
    score: 4.7,
  },
  {
    name: "Brasil",
    score: 4.4,
  },
  {
    name: "Canadá",
    score: 5.0,
  },
  {
    name: "Chile",
    score: 4.1,
  },
  {
    name: "Colombia",
    score: 4.7,
  },
  {
    name: "México",
    score: 4.8,
  },
  {
    name: "Panamá",
    score: 4.3,
  },
  {
    name: "Perú",
    score: 4.8,
  },
  {
    name: "Uruguay",
    score: 4.7,
  },
  {
    name: "Zona Hispana",
    score: 5.0,
  },
];

export const RESULT_SUPPORT_AVG = 4.39;
export const RESULT_SUPPORT_COUNT = 177;

export const RESULT_SOLUTIONS = [
  {
    name: "APOLLO INFINITY",
    score: 4.2,
  },
  {
    name: "AVIS",
    score: 4.0,
  },
  {
    name: "BEAUTY STORE",
    score: 3.8,
  },
  {
    name: "FENIX",
    score: 4.6,
  },
  {
    name: "FRIDAY",
    score: 3.7,
  },
  {
    name: "MERCURIO",
    score: 3.7,
  },
  {
    name: "PLV",
    score: 4.7,
  },
  {
    name: "PMT",
    score: 4.3,
  },
  {
    name: "TIMBO",
    score: 5.0,
  },
];

export const COMMENT_NEGATIVE = -1;
export const COMMENT_NEUTRAL = 0;
export const COMMENT_POSITIVE = 1;
export const COMMENTS = [
  {
    sem: COMMENT_POSITIVE,
    label:
      "quisiera agregar que todos en DSUITE no solo que son super rápidos para resolver inconvenientes sino que super serviciales, atentos, explicativos. La verdad es un placer trabajar así!",
  },
  {
    sem: COMMENT_POSITIVE,
    label:
      "los procesos son muy buenos, y el tiempo de respuesta ante algún inconveniente es excelente.",
  },
  {
    sem: COMMENT_POSITIVE,
    label:
      "la verdad el soporte que tenemos con Dsuite es excelente, siempre que queremos agregar nuevas funcionalidades el proveedor responde de forma muy rápida y con buenas soluciones; es clave para la operación contar con un proveedor así, gracias!",
  },
  {
    sem: COMMENT_NEUTRAL,
    label:
      "Poder comprar durante todo el mes, que la compra mínima de productos de la DPGP no fueran en grandes cantidades y que esten más productos de Kerastase",
    solution: "(Beauty Store)",
  },
  {
    sem: COMMENT_NEGATIVE,
    label: "Cambiaría el interfaz del usuario. No es muy amigable o intuitiva",
  },
  {
    sem: COMMENT_NEGATIVE,
    label: "Más rapidez del Sistema",
  },
];

export const NEXT_ACTIONS = [
  "Trabajaremos en optimizar rendimiento para mejorar tiempos de respuesta del Sistema",
  "Trabajaremos en rediseño y mejora de user experience",
  "Comunicaremos al negocio los comentarios que estan fuera del alcance de IT",
];
